// newgen FastOrderForm — гидратируется поверх SSR-формы, рендерящейся
// в `pages/blocks/_form.html.slim`. Сабмит уходит на /api/fast_order
// (не v3 API; это тенант-уровневый endpoint Website::Api::FastOrdersController).

import React from 'react';
import InputMask from 'react-input-mask';
import { observer } from '../../shared/observer';

const csrfToken = () => {
  const m = document.querySelector("meta[name='csrf-token']");
  return m ? m.getAttribute('content') : '';
};

class FastOrderFormView extends React.Component {
  state = { name: '', phone: '', sending: false, sent: false, error: null };

  setField = (field) => (e) => {
    this.setState({ [field]: e.target.value, error: null });
  };

  submit = async (e) => {
    e.preventDefault();
    // Анти-дабл-сабмит: повторный submit (Enter) до ре-рендера disabled игнорируем.
    if (this.state.sending) return;
    // Поля выключаются целиком (block.content.with_phone / with_name), поэтому
    // и проверяем только то, что реально показано.
    const withPhone = this.props.params.with_phone !== false;
    const withName = this.props.params.with_name !== false;
    if (withPhone) {
      const phoneDigits = (this.state.phone || '').replace(/\D/g, '');
      if (phoneDigits.length < 10) {
        this.setState({ error: 'Укажите телефон' });
        return;
      }
    }
    if (!withPhone && withName && !(this.state.name || '').trim()) {
      this.setState({ error: 'Укажите имя' });
      return;
    }
    this.setState({ sending: true, error: null });
    try {
      const resp = await fetch('/api/fast_order', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken(),
        },
        body: JSON.stringify({
          name: this.state.name,
          phone: this.state.phone,
          title: this.props.params.header || '',
          page_url: window.location.href,
        }),
      });
      const data = await resp.json().catch(() => ({}));
      if (data.status === 'ok') {
        this.setState({ sent: true, name: '', phone: '', sending: false });
        if (this.props.params.js) {
          try { eval(this.props.params.js); } catch (err) { /* noop */ }
        }
      } else {
        this.setState({ error: 'Не удалось отправить заявку', sending: false });
      }
    } catch (err) {
      this.setState({ error: 'Не удалось отправить заявку', sending: false });
    }
  };

  render() {
    if (this.state.sent) {
      return (
        <div className="ng-fast-order__sent">Спасибо! Скоро с вами свяжется наш менеджер.</div>
      );
    }
    const auth = this.props.auth || {};
    const mask = (auth.phoneMaskInfo && auth.phoneMaskInfo.phone_mask)
      || '+9 (999) 999-99-99';
    // Владелец может выключить любое поле целиком (но не оба — это стережёт
    // и редактор блока, и шаблон).
    const withPhone = this.props.params.with_phone !== false;
    const withName = this.props.params.with_name !== false;
    return (
      <form className="ng-fast-order__form" onSubmit={this.submit}>
        {withName && (
        <div className="ng-fast-order__row">
          <input
            type="text"
            placeholder="Имя"
            value={this.state.name}
            onChange={this.setField('name')}
            disabled={this.state.sending}
          />
        </div>
        )}
        {withPhone && (
        <div className="ng-fast-order__row">
          <InputMask
            mask={mask}
            value={this.state.phone}
            onChange={this.setField('phone')}
            type="tel"
            placeholder="Телефон"
            className="input__text"
            disabled={this.state.sending}
          />
        </div>
        )}
        {this.state.error && (
          <div className="order-message">{this.state.error}</div>
        )}
        <div className="ng-fast-order__actions">
          <button type="submit" className="btn btn--lg" disabled={this.state.sending}>
            {this.state.sending ? 'Отправляем…' : 'Заказать'}
          </button>
        </div>
      </form>
    );
  }
}

export const FastOrderForm = observer(FastOrderFormView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Pages/FastOrderForm.jsx